import { DependencyContextType, ReportItemTreeContextValue, TreeContextValue } from "@/frontend/types/navigationTypes";
import {
	attachInstruction,
	extractInstruction,
} from '@atlaskit/pragmatic-drag-and-drop-hitbox/tree-item';
import { DropIndicator } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/tree-item';
import { createContext } from "react";

export const DependencyContext = createContext<DependencyContextType>({
	DropIndicator,
	attachInstruction,
	extractInstruction,
});

export const TreeContext = createContext<TreeContextValue>({
	uniqueContextId: Symbol('uniqueId'),
	getPathToItem: () => [],
	getMoveTargets: () => [],
	getChildrenOfItem: () => [],
	registerTreeItem: () => {},
});

export const ReportItemTreeContext = createContext<ReportItemTreeContextValue>({
	uniqueContextId: Symbol('uniqueId'),
	getPathToItem: () => [],
	getMoveTargets: () => [],
	getChildrenOfItem: () => [],
	registerTreeItem: () => {},
});
